// extracted by mini-css-extract-plugin
export default {"styles":"FeedFooter_styles__YXCVn"};